import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  taxIncludedDE: {
    id: 'pd.price.tax.included',
    defaultMessage: ', inkl. MwSt',
  },
});
